import { render } from "./sharesortlist.vue?vue&type=template&id=64b7f74e"
import script from "./sharesortlist.vue?vue&type=script&lang=js"
export * from "./sharesortlist.vue?vue&type=script&lang=js"

import "./sharesortlist.vue?vue&type=style&index=0&id=64b7f74e&lang=scss"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__